export default __webpack_public_path__ + "static/media/map.2f96574b.svg";